/**
 * Spec 230 — every Boxicon in the app renders through here.
 *
 * The accessibility rule is baked in rather than left to 104 call sites: an
 * icon beside text is decoration and is hidden from assistive tech; an icon
 * that IS the control gets its name from the control, never from a title
 * tooltip. Gate 230.A.4 asserts this over the rendered app.
 */
export function Icon({ name, className }: { name: string; className?: string }) {
  return <i className={`bx ${name}${className ? ' ' + className : ''}`} aria-hidden="true" />;
}

/** The spinner. `bx-spin` is Boxicons' own animation, so no Tailwind keyframes. */
export function Spinner({ className }: { className?: string }) {
  return <Icon name="bx-loader-alt bx-spin" className={className} />;
}
